
  import { Vue, Component, Prop } from "vue-property-decorator";
@Component({})
  export default class ApplicationCard extends Vue {
    @Prop({type: String, required: false, default:'none'}) readonly fill!: string;
    @Prop({type: String, required: false, default:'#717986'}) readonly stroke!: string;

  }
  